export default __webpack_public_path__ + "static/media/Background_00117.f88cefb5.png";